module.exports = __webpack_public_path__ + "themify.9c8e96ecc7fa01e6ebcd.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/assets/fonts/themify.svg?-fvbane
// module id = ../../../../../src/assets/fonts/themify.svg?-fvbane
// module chunks = styles